// Typelizer digest e0ec450c470d32b4ac3d3e82675aa92b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET / */
  main: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/', {}, options),
    method: 'get',
  }),

  /** GET /terms */
  terms: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/terms', {}, options),
    method: 'get',
  }),

  /** GET /privacy */
  privacy: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/privacy', {}, options),
    method: 'get',
  }),
}
